import React, { Component } from 'react'

class About extends Component {
  render() {
    return (
      <div className="about">
        <h1>
          Edit About component or pages/about.jsx to include your information.
        </h1>
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/About.jsx